import ImageConfigurator from './ImageConfigurator';

export default ImageConfigurator;
